export const MY_SETTINGS_SECTION = {
  PERSONAL_DETAILS: 'personal_details',
} as const;
